module.exports = __webpack_public_path__ + "static/media/Herb.65d84d53.jpg";